"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const getStylesNormal = () => ({
    wrapper: (theme) => ({
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    }),
});
const getStylesSmall = () => ({
    wrapper: (theme) => ({
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(1),
    }),
});
/**
 *
 * @category component
 */
const CardContentError = ({ contact, children, small, ...props }) => {
    const styles = small ? getStylesSmall(props) : getStylesNormal(props);
    return (react_1.default.createElement(Box_1.default, { sx: styles.wrapper }, children ? (children) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, "Try to refresh the page, it might be a temporary problem"),
        react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, `If the problem persists, please contact ${contact}`)))));
};
exports.default = CardContentError;
